import type {
  Axis,
  ExportSettings,
  ExportType,
  KeyframeCleaningMethod,
} from './postMotionFromText';
import apiRequest from './apiRequest';

export type SceneExportSettings = Omit<ExportSettings, 'characterID'> & {
  characterID?: string;
};

export type SceneExportStatus =
  | 'QUEUED'
  | 'GENERATING'
  | 'COMPLETED'
  | 'FAILED'
  | 'REJECTED'
  | 'CANCELLED';

export type SceneObjectExport = {
  exportID: string;
  objectID: string;
  objectReferenceName: string;
  requestedType: ExportType;
  sceneID: string;
  sceneName: string;
  status: SceneExportStatus;
};

export type SceneExportResponse = {
  exports: SceneObjectExport[];
  downloadURL?: string;
};

export type CreateSceneExportRequest = {
  objectReferenceNamesToExport?: string[];
  exportSettings?: SceneExportSettings;
};

export type { Axis, ExportType, KeyframeCleaningMethod };

export default async function postExternalSceneExport(
  apiKey: string,
  sceneID: string,
  exportRequest: CreateSceneExportRequest = {},
) {
  return await apiRequest<SceneExportResponse>(
    'external-mogen',
    `/exports/scenes/${encodeURIComponent(sceneID)}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify(exportRequest),
    },
  );
}
